import { Table } from 'reactstrap';

const StoreOrderList = (props) => {
  const { orderData, searchText } = props;

  return (
    <div className="table-responsive dt-table">
      <Table className="OrderListTable table mb-0">
        <thead>
          <tr>
            <th>SI.No</th>
            <th>Reference No</th>
            <th>Name</th>
            <th>Address</th>
            <th>Grand Total</th>
            <th>Status</th>
            <th>Store</th>
            <th></th>
          </tr>
        </thead>
        {orderData.length > 0 ? (
          <tbody>
            {orderData.map((order, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                  <td>
                    <p className="m-0 d-flex gap-1">
                      <strong>{order.order_no}</strong>
                    </p>
                    <p className="m-0 fs-11">{order.order_date}</p>
                  </td>
                </td>
                <td>
                  <p className="m-0 d-flex gap-1">
                    <strong>{order.customer_name}</strong>
                  </p>
                  <p className="m-0 fs-11">Mob: {searchText}</p>
                </td>
                <td>{order.address}</td>
                <td>
                  <strong>{order.total}</strong>
                </td>
                <td>
                  <span className="bg-soft-success text-success badge badge badge-secondary">
                    {order.status}
                  </span>
                </td>
                <td>
                  <p className="m-0 d-flex gap-1">
                    <strong>{order.store_code}</strong>
                  </p>
                  <p className="m-0 fs-11">{order.country}</p>
                </td>
                <td>
                  <div className="d-flex gap-2">
<a
  className="btn btn-sm btn-outline-warning waves-effect waves-light"
  target="_blank"
  href={`/orders/${order.OrderId || order.id}/?order_mode=store&orderCn=ae&showPopup=false&orderno=${encodeURIComponent(order.OrderNo || order.order_no || '')}&mobile=${encodeURIComponent(order.Mobile || order.mobile || order.customer_mobile || searchText || '')}`}
>   
                      <i className="mdi mdi-eye-outline"></i>{' '}
                    </a>
                    <a
                      href="OrderLogReport/30000011356"
                      type="button"
                      className="btn btn-sm btn-outline-secondary waves-effect waves-light"
                    >
                      <i className="mdi mdi-information-outline"></i>{' '}
                    </a>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <p>No orders found.</p>
        )}
      </Table>
    </div>
  );
};

export default StoreOrderList;
